import { render } from "./MenuNavigationItem.vue?vue&type=template&id=251b8a9b"
import script from "./MenuNavigationItem.vue?vue&type=script&lang=js"
export * from "./MenuNavigationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__